/**
 * 学习模块类型的显示信息和 payload Schema，读取 contracts/activities/bundle.json（build-bundle.mjs 生成，
 * 后端、iOS、安卓读同一份）。新增模块不用在网页版写名称、颜色（docs/插件开发.md）。
 */
import bundle from "../../../contracts/activities/bundle.json";
import type { JSONObject } from "../core/models";

export interface ActivityInfo {
  type: string;
  name: string;
  description: string;
  /** 学生端短标签（"阅读"）和家长端内容列表色块上的字（"PDF"） */
  badge: { label: string; short: string; tint: string; ink: string };
  /** lucide 图标名 */
  icon: string;
  /** 家长端能新建（web_activity 走游戏库） */
  creatable: boolean;
  payloadVersion: number;
  /** payload 的 JSON Schema（按 x- 标注生成设置表单） */
  schema: JSONObject | null;
}

interface BundleActivity {
  type: string;
  name: string;
  description?: string;
  badge: { label: string; short: string; tint: string; ink: string };
  icons?: { web?: string };
  creatable?: boolean;
  payload_version: number;
  schema?: unknown;
}

/** 按注册表顺序 */
export const ACTIVITIES: ActivityInfo[] = (bundle.activities as BundleActivity[]).map((a) => ({
  type: a.type,
  name: a.name,
  description: a.description ?? "",
  badge: a.badge,
  icon: a.icons?.web ?? "star",
  creatable: a.creatable === true,
  payloadVersion: a.payload_version,
  schema: (a.schema as JSONObject | undefined) ?? null,
}));

/** 没登记的类型（网页版遇到新模块） */
function unknown(type: string): ActivityInfo {
  return { type, name: type, description: "", badge: { label: "学习", short: "学习", tint: "#EFEAE0", ink: "#5B6270" }, icon: "star", creatable: false, payloadVersion: 1, schema: null };
}

export function activityInfo(type: string | null | undefined): ActivityInfo {
  return ACTIVITIES.find((a) => a.type === type) ?? unknown(type ?? "");
}
